import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import * as S from './styles'
import { TrustBarColumn } from './trust-bar.model'

const cyrelaLogo = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/logos/cyrela/white-with-text.svg`

export const columns: TrustBarColumn[] = [
  {
    key: 'cyrela',
    content: (
      <S.Brand>
        <Text as="span" size="body2" color="var(--colors-neutral-text-contrast-default)">
          Empresa do grupo
        </Text>
        <NextImage src={cyrelaLogo} alt="Cyrela" width={132} height={28} style={{ objectFit: 'contain' }} />
      </S.Brand>
    )
  },
  {
    key: 'credit',
    content: (
      <S.Credit>
        <Text as="span" size="body2" color="var(--colors-neutral-text-contrast-default)">
          Mais de
        </Text>
        <Text as="span" size="heading4" weight="bold" color="var(--colors-neutral-text-contrast-default)">
          6 bilhões
        </Text>
        <Text as="span" size="body1" color="var(--colors-neutral-text-contrast-default)">
          em crédito liberado
        </Text>
      </S.Credit>
    )
  },
  {
    key: 'partners',
    content: (
      <S.Credit>
        <Text as="span" size="body2" color="var(--colors-neutral-text-contrast-default)">
          Atuação em todo o
        </Text>
        <Text as="span" size="heading4" weight="bold" color="var(--colors-neutral-text-contrast-default)">
          Brasil
        </Text>
      </S.Credit>
    )
  },
]
